module.exports = __webpack_public_path__ + "assets/img/img_2_9_4.a9b18cb7.png";